<style lang="less">
#sms_used_dialog_tips {
	width: 100%;
	.el-dialog {
		top: 50%;
		transform: translateY(-50%);
		.el-dialog__header {
			padding: 16px;
			.el-dialog__headerbtn {
				.el-dialog__close {
					font-size: 14px;
				}
			}
			.el-dialog__title {
				font-size: 14px;
				color: #323233;
			}
		}
		.el-dialog__body {
			padding: 32px 24px;
		}
		.el-dialog__footer {
			padding: 0 16px 24px;
		}
	}
	.btn {
		padding: 8px 22px;
		font-size: 14px;
		color: #323233;
		&.confirm {
			color: #ffffff;
			border-color: #165dff;
			background-color: #165dff;
		}
	}
	.tips_text {
		color: #1d2129;
		font-size: 14px;
		line-height: 22px;
		display: flex;
		align-items: center;
		.el-icon {
			font-size: 18px;
			color: #ff7d00;
			margin-right: 9px;
		}
	}
}
</style>
<template>
	<el-dialog title="短信包提示" id="sms_used_dialog_tips" :visible.sync="showStatus" width="510px" top="0">
		<div class="tips_text"><i class="el-icon el-icon-warning"></i>您的短信包剩余条数已用尽，请及时充值</div>
		<span slot="footer" class="dialog-footer">
			<el-button class="btn" @click="close">取消</el-button>
			<el-button class="btn confirm" type="primary" @click="confirm">去购买</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			showStatus: false,
		};
	},
	comments: {
		smsCodeBuyUrl() {
			return '/views/toShortMessage';
		},
	},
	methods: {
		show() {
			this.showStatus = true;
		},
		confirm() {
			window.open(this.smsCodeBuyUrl);
			this.showStatus = false;
		},
		close() {
			this.showStatus = false;
		},
	},
};
</script>
